module.exports = __webpack_public_path__ + "static/media/quem-sou.c6ef9606.png";